import React, { useState, useRef, useEffect } from 'react'
import './Accordion.css'

interface AccordionProps {
  title?: React.ReactNode
  children: React.ReactNode
  defaultOpen?: boolean
  footer?: React.ReactNode
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
  footer,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState<number | undefined>(
    undefined,
  )

  // 内容の高さを測定して設定
  useEffect(() => {
    if (isOpen && contentRef.current) {
      const height = contentRef.current.scrollHeight
      setContentHeight(height)
    } else {
      setContentHeight(0)
    }
  }, [isOpen])

  return (
    <div className="accordion">
      <button
        className={`accordion-header ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {title}
        <span className={`accordion-icon ${isOpen ? 'rotate' : ''}`}>▼</span>
      </button>
      <div
        className="accordion-content-wrapper"
        style={{
          height:
            contentHeight !== undefined ? `${contentHeight}px`
            : isOpen ? 'auto'
            : '0',
        }}
      >
        <div ref={contentRef} className="accordion-content">
          {children}
          {footer && <div className="accordion-footer">{footer}</div>}
        </div>
      </div>
    </div>
  )
}

export default Accordion
